import { Component, OnInit } from '@angular/core';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { ScrubberDataService } from 'src/app/services/scrubber-data.service';
import { StatuteCategoryMapping } from '../models/batch-row';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-crim-grid-module',
  templateUrl: './crim-grid-module.component.html',
  styleUrls: ['./crim-grid-module.component.less']
})

export class CrimGridModuleComponent implements OnInit{
  def: NgbNav
  activeId: number = 1;
  state: string;
  ngOnInit(){
    this.scrubs.loadCategories();
  }
  constructor(public scrubs : ScrubberDataService, public toast : ToastrService){}

  setState(e: any){
    console.log('setting new state from parent component', e);
    this.state = e;
  }

  logg(e : number){
    // console.log('inside the crim grid module', e);
    this.scrubs.loadCharges(this.state,e);
  }
}
